import React, {FC, useMemo, useState} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {SearchDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/search/searchDropdown';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {computeCustomFieldIconName} from '../../../helpers/customFieldViewHelpers';
import {fuzzySearchBuilder} from '../../../helpers/fuzzySearchHelpers';
import {CustomFieldModel} from '../../../models/api/customFieldModel';

interface LensCustomFieldSearchDropdownProps extends PopoverTransferProps {
  customFields: ReadonlyArray<CustomFieldModel>;
  selectedIds: ReadonlyArray<number>;
  onSelect: (model: CustomFieldModel) => void;
}

const fuzzySearcher = fuzzySearchBuilder<CustomFieldModel>((customField) => [customField.name]);

export const LensCustomFieldSearchDropdown: FC<LensCustomFieldSearchDropdownProps> = ({
  customFields,
  selectedIds,
  onSelect,
  ...popoverProps
}) => {
  const [query, setQuery] = useState('');

  const filteredCustomFields = useMemo(() => fuzzySearcher(customFields, query), [customFields, query]);

  return (
    <SearchDropdown
      {...popoverProps}
      data={filteredCustomFields}
      headerTitle={
        <Trans id="lens-form-multiselect-customfields-dropdown-header">
          Select conversation custom field
        </Trans>
      }
      query={query}
      onQueryChange={setQuery}
      renderRow={(customField) => (
        <DropdownItem
          renderTooltip={() => customField.description}
          isChecked={selectedIds.includes(customField.id)}
          onSelect={() => onSelect(customField)}
        >
          <DropdownItemIcon
            label={customField.name}
            iconName={computeCustomFieldIconName(customField.type, VisualSizesEnum.SMALL)}
          />
          <DropdownItemContent>{customField.name}</DropdownItemContent>
        </DropdownItem>
      )}
    />
  );
};
